// src/utils/currency.ts
export const currencyFormatter = (value: number, locale = 'en-KE', currency = 'KES') => {
    if (typeof value !== 'number') {
        value = parseFloat(value) || 0;
    }
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
    }).format(value);
};